<script lang="ts">
  import { onMount } from "svelte";
  import type { Maybe, Map, MapTextbox, MapIcon } from "../types";

  export let heraldMap: Maybe<Map>;

  $: layers = heraldMap?.template?.layerImages || [];
  $: textboxes = heraldMap?.textboxes || [];
  $: icons = heraldMap?.icons || [];

  function prefetch(src: string) {
    let image = new Image();
    image.src = src;
  }

  onMount(function () {
    layers.forEach((layer: string) => {
      prefetch(layer);
    });

    textboxes.forEach((textbox: MapTextbox) => {
      if (textbox.iconSrc) {
        prefetch(textbox.iconSrc);
      }
    });

    icons.forEach((icon: MapIcon) => {
      if (icon.src) {
        prefetch(icon.src);
      }
    });
  });
</script>
